import React from 'react';
import {
  ActivityIndicator,
  Pressable,
  StyleSheet,
  View,
} from 'react-native';
import { spacing } from '../constants/spacing';
import { useAppColors } from '../context/PreferencesContext';
import { webPointer } from '../utils/webLayout';

export function ConfigurationDeleteButton({
  entityLabel,
  disabled,
  loading,
  onPress,
  placement = 'corner',
}: {
  entityLabel: string;
  disabled?: boolean;
  loading?: boolean;
  onPress: () => void;
  placement?: 'corner' | 'inline';
}) {
  const palette = useAppColors();
  const inactive = disabled || loading;

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={`Delete ${entityLabel}`}
      disabled={inactive}
      hitSlop={8}
      onPress={onPress}
      style={[
        styles.hit,
        webPointer,
        placement === 'corner' ? styles.corner : null,
        inactive ? styles.inactive : null,
      ]}
    >
      {loading ? (
        <ActivityIndicator size="small" color={palette.error} />
      ) : (
        <TrashIcon color={palette.error} />
      )}
    </Pressable>
  );
}

function TrashIcon({ color }: { color: string }) {
  return (
    <View style={iconStyles.root} accessibilityElementsHidden>
      <View style={[iconStyles.lid, { backgroundColor: color }]} />
      <View style={[iconStyles.body, { borderColor: color }]}>
        <View style={[iconStyles.line, { backgroundColor: color }]} />
        <View style={[iconStyles.line, { backgroundColor: color }]} />
        <View style={[iconStyles.line, { backgroundColor: color }]} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  hit: {
    width: 36,
    height: 36,
    alignItems: 'center',
    justifyContent: 'center',
  },
  corner: {
    alignSelf: 'flex-end',
    marginTop: -spacing.sm,
    marginRight: -spacing.sm,
    marginBottom: -spacing.xs,
  },
  inactive: {
    opacity: 0.45,
  },
});

const iconStyles = StyleSheet.create({
  root: { width: 18, height: 20, alignItems: 'center' },
  lid: {
    width: 14,
    height: 3,
    borderRadius: 2,
    marginBottom: 2,
  },
  body: {
    width: 12,
    height: 14,
    borderWidth: 1.8,
    borderRadius: 2,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    overflow: 'hidden',
    paddingHorizontal: 1,
  },
  line: {
    width: 1.5,
    height: 8,
    borderRadius: 1,
  },
});
